export class UnidadMedidaDto {
    constructor(
      public readonly Id: number,
      public readonly Nombre: string | null,     
      public readonly Abreviatura: string | null,
      public  Activo: boolean
    ) {}
  }
  
  export class SearchUnidadMedidaRequest {
    constructor(
      public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly Codigo: string | null,
    public readonly VerSoloActivos: boolean,
    ) {}
  }
  export class SaveUnidadMedidaDto {
    constructor(
      public Nombre: string | null,
      public Codigo: string | null,
      public Activo: boolean
    ) {}
  }
  
  export class SearchUnidadMedidaResponse {
    constructor(
      public readonly count: number,
      public readonly result: UnidadMedidaDto[]
    ) {}
  }
  